<label class="label-container">
    <div class="toggle" tabindex="0" (keydown.enter)="handleActivate($event)" (keydown.space)="handleActivate($event)">
        <input
            #switchInput
            role="switch"
            [id]="id + '-switch'"
            [attr.aria-labelledby]="labelledById"
            [attr.data-testid]="dataTestId"
            [attr.aria-describedby]="describedById"
            [checked]="isSwitchEnabled"
            (click)="switchClicked()"
            tabindex="-1"
            type="checkbox"
            class="switch-input" />
        <div class="toggle-switch"></div>
        <div class="block-label"> <ng-content></ng-content></div>
        <span class="state">
            <span i18n="@@hermes.accessibility.on" class="toggle-on" hSrOnlyNoSnippet>On</span>
            <span i18n="@@hermes.accessibility.off" class="toggle-off" hSrOnlyNoSnippet>Off</span>
        </span>
    </div>
</label>
